import { Checkbox, TextField } from '@/components/design-system'

export interface PlanFormData {
  [key: string]: string
  name: string
  slug: string
  description: string
  stripe_product_id: string
  stripe_price_id: string
  price_cents: string
  currency: string
  published: string
  position: string
}

export type PlanFormErrors = Partial<Record<keyof PlanFormData, string>>

interface Props {
  data: PlanFormData
  errors: PlanFormErrors
  setData: (key: keyof PlanFormData, value: string) => void
}

export function blankPlanFormData(): PlanFormData {
  return {
    name: '',
    slug: '',
    description: '',
    stripe_product_id: '',
    stripe_price_id: '',
    price_cents: '0',
    currency: 'BRL',
    published: 'true',
    position: '100',
  }
}

export default function PlanFormFields({ data, errors, setData }: Props) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        <TextField
          label="Nome"
          value={data.name}
          onChange={(value) => setData('name', value)}
          error={errors.name}
        />
        <TextField
          label="Slug"
          value={data.slug}
          onChange={(value) => setData('slug', value)}
          error={errors.slug}
          helpText="Usado em URLs internas e metadados do Stripe."
        />
      </div>

      <TextField
        label="Descrição"
        value={data.description}
        onChange={(value) => setData('description', value)}
        error={errors.description}
        multiline={3}
      />

      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        <TextField
          label="Preço em centavos"
          type="number"
          value={data.price_cents}
          onChange={(value) => setData('price_cents', value)}
          error={errors.price_cents}
        />
        <TextField
          label="Moeda"
          value={data.currency}
          onChange={(value) => setData('currency', value)}
          error={errors.currency}
        />
        <TextField
          label="Ordem"
          type="number"
          value={data.position}
          onChange={(value) => setData('position', value)}
          error={errors.position}
        />
      </div>

      <TextField
        label="Stripe Product ID"
        value={data.stripe_product_id}
        onChange={(value) => setData('stripe_product_id', value)}
        error={errors.stripe_product_id}
        placeholder="prod_..."
      />
      <TextField
        label="Stripe Price ID"
        value={data.stripe_price_id}
        onChange={(value) => setData('stripe_price_id', value)}
        error={errors.stripe_price_id}
        placeholder="price_..."
      />

      <Checkbox
        label="Publicado"
        checked={data.published === 'true'}
        onChange={(checked) => setData('published', checked ? 'true' : 'false')}
      />
    </div>
  )
}
